<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.auditStatus"
          placeholder="审核状态"
        >
          <el-option
            v-for="(item, i) in auditStatusList"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
       <el-form-item class="m-l-14">
        <el-input
          size="small"
          v-model.trim="filters.reportDeptName"
          placeholder=" 申报部门"
        ></el-input>
      </el-form-item>
      <el-form-item class="m-l-14">
        <el-input
          size="small"
          v-model.trim="filters.className"
          placeholder="班级名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { getEnums } from "@/utils/common.js";

export default {
  components: { butn },
  data() {
    return {
      filters: {},
      auditStatusList: [],
    };
  },
  created() {
    getEnums(["AUDIT_STATUS"], this, ["auditStatusList"], [true]);
  },
  methods: {
    query() {
      this.$emit("search", { ...this.filters });
    },
    reset() {
      this.filters = {};
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
  